import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormGroup, FormRow, Row, Textarea } from "styles/forms/main";
import {
    Input,
    RejectionReason,
    SelectWithSearch,
    UploadAttachments,
    VerifyComponent,
} from "components";
import { deleteSingleAttachment } from "modules/shared/api";
import { setMessage } from "modules/shared/notification/slice";
import { getUserRoles } from "modules/auth/slice";
import { HAS_ACOMPANY } from "../staticData";

function CompanyInfo({
    newSupplierData,
    handleSupplierDetailsChange,
    isEditable,
    errorList,
    errors,
    supplierAttachments,
    setSupplierAttachments,
    selectedSupplierId,
    isQARole,
    handleObjections,
    objections,
    isAuthorizedToCreate,
}) {
    const dispatch = useDispatch();
    const getCurrentUserRole = useSelector(getUserRoles())?.filter((role) => role === "reviewer");
    const [objection, setObjections] = useState({});

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    const handleDeleteUploadedItem = (id) => {
        deleteSingleAttachment(id).then(() => {
            setSupplierAttachments(supplierAttachments.filter((item) => item?.id !== id));
            dispatch(
                setMessage({
                    content: `Attachment deleted successfully`,
                    isError: false,
                })
            );
        });
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    return (
        <>
            <FormRow>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            isEditable={isEditable}
                            isMulti={false}
                            label="Has a company"
                            name="hasACompany"
                            options={HAS_ACOMPANY}
                            handleChange={(value) =>
                                handleSupplierDetailsChange(value, "hasACompany")
                            }
                            value={newSupplierData?.hasACompany}
                            placeholder="Select"
                            required
                            errorMessage={
                                errorList?.hasACompany
                                    ? errorList?.hasACompany
                                    : errors?.company_name?.[0]
                            }
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("hasACompany")}
                                handleVerify={() =>
                                    handleVerify(
                                        "hasACompany",
                                        "Has Company",
                                        "Company Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.hasACompany?.verified
                                        ? objection?.hasACompany?.verified
                                        : false
                                }
                                objection={
                                    objection?.hasACompany?.haveobjection
                                        ? objection?.hasACompany?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Has Company")}
                    </Row>
                    {objection?.hasACompany?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Has Company",
                                    "Company Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                {newSupplierData?.hasACompany?.value === true && (
                    <FormGroup>
                        <Row>
                            <Input
                                isEditable={isEditable}
                                label="Company Name"
                                name="companyName"
                                value={newSupplierData?.companyName}
                                onChange={(e) => handleSupplierDetailsChange(e)}
                                type="text"
                                required
                                placeholder="مثال: الشركة المتحدة للتصنيع"
                                errorMessage={errorList?.companyName && errorList?.companyName}
                            />
                            {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("companyName")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "companyName",
                                            "Company Name",
                                            "Company Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.companyName?.verified
                                            ? objection?.companyName?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.companyName?.haveobjection
                                            ? objection?.companyName?.haveobjection
                                            : false
                                    }
                                />
                            )}
                            {renderObjection("Company Name")}
                        </Row>
                        {objection?.companyName?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Company Name",
                                        "Company Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                )}
            </FormRow>
            {newSupplierData?.hasACompany?.value === true && (
                <FormRow>
                    <FormGroup>
                        <Row>
                            <UploadAttachments
                                label="Commercial Registration"
                                required
                                onFilesChange={(e) =>
                                    handleSupplierDetailsChange(
                                        e,
                                        "commercialRegistrationAttachments"
                                    )
                                }
                                isEditable={isEditable}
                                errorMessage={
                                    errorList?.commercialRegistrationAttachments &&
                                    errorList?.commercialRegistrationAttachments
                                }
                                onDeleteUploadedItem={handleDeleteUploadedItem}
                                uploadedAttachments={
                                    selectedSupplierId &&
                                    supplierAttachments?.filter(
                                        (item) => item?.documentType === "commercial_register"
                                    )
                                }
                                maxLength={1}
                                showConfirmation
                            />
                            {getCurrentUserRole[0] === "reviewer" &&
                                supplierAttachments?.filter(
                                    (item) => item?.documentType === "commercial_register"
                                )?.length === 1 &&
                                isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("commercialRegistrationPhoto")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "commercialRegistrationPhoto",
                                                "Commercial Registration",
                                                "Company Info - Supplier",
                                                "supplier_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.commercialRegistrationPhoto?.verified
                                                ? objection?.commercialRegistrationPhoto?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.commercialRegistrationPhoto?.haveobjection
                                                ? objection?.commercialRegistrationPhoto
                                                      ?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            {renderObjection("Commercial Registration")}
                        </Row>
                        {objection?.commercialRegistrationPhoto?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Commercial Registration",
                                        "Company Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <UploadAttachments
                                label="Tax Card"
                                required
                                onFilesChange={(e) =>
                                    handleSupplierDetailsChange(e, "taxCardAttachments")
                                }
                                isEditable={isEditable}
                                errorMessage={
                                    errorList?.taxCardAttachments && errorList?.taxCardAttachments
                                }
                                onDeleteUploadedItem={handleDeleteUploadedItem}
                                uploadedAttachments={
                                    selectedSupplierId &&
                                    supplierAttachments?.filter(
                                        (item) => item?.documentType === "tax_card"
                                    )
                                }
                                maxLength={1}
                                showConfirmation
                            />
                            {getCurrentUserRole[0] === "reviewer" &&
                                supplierAttachments?.filter(
                                    (item) => item?.documentType === "tax_card"
                                )?.length === 1 &&
                                isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("taxCardPhoto")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "taxCardPhoto",
                                                "Tax Card",
                                                "Company Info - Supplier",
                                                "supplier_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.taxCardPhoto?.verified
                                                ? objection?.taxCardPhoto?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.taxCardPhoto?.haveobjection
                                                ? objection?.taxCardPhoto?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            {renderObjection("Tax Card")}
                        </Row>
                        {objection?.taxCardPhoto?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Tax Card",
                                        "Company Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                </FormRow>
            )}
        </>
    );
}

export default CompanyInfo;
